import { RatingSelector } from './RatingSelector';

import styles from './RatingInner.module.scss';

interface propTypes {
  selectedRating: number;
  setSelectedRating: React.Dispatch<React.SetStateAction<number>>;
  onSubmit: () => void;
}

export const RatingInner = ({
  selectedRating,
  setSelectedRating,
  onSubmit,
}: propTypes) => {
  return (
    <div>
      <div className={styles.circle}>
        <img
          className={styles.star}
          src='/images/icon-star.svg'
          alt='star icon'
        ></img>
      </div>
      <h1>How did we do?</h1>
      <p>
        Please let us know how we did with your support request. All feedback is
        appreciated to help us improve our offering!
      </p>
      <RatingSelector
        selectedRating={selectedRating}
        setSelectedRating={setSelectedRating}
      />
      <button onClick={onSubmit} className={styles.button}>
        Submit
      </button>
    </div>
  );
};
